import { render, staticRenderFns } from "./OrganizationLeadCreateModal.vue?vue&type=template&id=2d7b2a1a&scoped=true&"
import script from "./OrganizationLeadCreateModal.vue?vue&type=script&lang=js&"
export * from "./OrganizationLeadCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7b2a1a",
  null
  
)

export default component.exports